<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="mx-auto py-12 container">
    <div class="mb-12 text-center">
      <NuxtImg src="/icons/guarantee_shield.svg" class="m-auto max-w-250px" />
      <h2 class="text-2xl font-bold -mt-5">
        {{ t('trustable.productpage.customer_guarantee.guarantee_of_satisfaction') }}
      </h2>
      <p class="mt-2 text-gray-600">
        {{ t('trustable.productpage.customer_guarantee.guarantee_of_satisfaction_desc') }}
      </p>
    </div>
    <div class="flex flex-col justify-around gap-y-5 text-center md:flex-row">
      <div class="w-full px-4 lg:w-1/3">
        <NuxtImg src="/icons/guarantee_gift.svg" class="m-auto max-w-70px" />

        <h2 class="text-md mt-4 font-bold">
          {{ t('trustable.productpage.customer_guarantee.yours_order_will_delivered_to_yours_doors') }}
        </h2>
        <p class="mt-2 text-xs text-gray-600">
          {{ t('trustable.productpage.customer_guarantee.yours_order_will_delivered_to_yours_doors_desc') }}
        </p>
      </div>
      <div class="w-full px-4 lg:w-1/3">
        <NuxtImg src="/icons/guarantee_box.svg" class="m-auto max-w-70px" />
        <h2 class="text-md mt-4 font-bold">
          {{ t('trustable.productpage.customer_guarantee.if_you_are_not_satisfied_with_product') }}
        </h2>
        <p class="mt-2 text-xs text-gray-600">
          {{ t('trustable.productpage.customer_guarantee.if_you_are_not_satisfied_with_product_desc') }}
        </p>
      </div>
      <div class="w-full px-4 lg:w-1/3">
        <NuxtImg src="/icons/guarantee_chat.svg" class="m-auto max-w-70px" />
        <h2 class="text-md mt-4 font-bold">
          {{ t('trustable.productpage.customer_guarantee.customer_support') }}
        </h2>
        <p class="mt-2 text-xs text-gray-600">
          {{ t('trustable.productpage.customer_guarantee.customer_support_desc') }}
        </p>
      </div>
    </div>
  </div>
</template>
